"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CashPaymentBill1: ['cash-payment-bill-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.818,16.125l2.331-1.043a2.044,2.044,0,0,0,.883-1.365L7.4,11.523l3.151-2.251a1.022,1.022,0,0,0,.428-.832V7.86A1.022,1.022,0,0,0,9.611,6.9L5.41,8.4a9.5,9.5,0,0,0-2.89,1.65L.75,11.523', 'M.75,21.75l2.3-1.683a2.871,2.871,0,0,1,1.7-.567h6.5', 'M11.25,19.5h3.592a1.021,1.021,0,0,0,.971-.676L17.649,13.5', 'M13.329,9.344a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M15.187 10.219L15.187 11.25', 'M15.187 3L15.187 4.031', 'M13.5,16.5H11.25A1.5,1.5,0,0,0,9.75,18h0a1.5,1.5,0,0,0,1.5,1.5', 'M18,13.5H13.5A1.5,1.5,0,0,0,12,15h0a1.5,1.5,0,0,0,1.5,1.5h3.114', 'M18.75,2.25h3a1.5,1.5,0,0,1,1.5,1.5V12a1.5,1.5,0,0,1-1.5,1.5H10.5', 'M5.25,5.25V3.75a1.5,1.5,0,0,1,1.5-1.5H12']],
  CashPaymentCoins: ['cash-payment-coins', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M14.250 5.250 A4.500 4.500 0 1 0 23.250 5.250 A4.500 4.500 0 1 0 14.250 5.250 Z', 'M18.75,12.75A3,3,0,1,1,13.5,10.766']],
  CashPaymentBills1: ['cash-payment-bills-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.893,12.75h6.75l.471.792a.966.966,0,0,1,0,1.071l-.3.447a.965.965,0,0,0-.06.967l.5,1a.966.966,0,0,1,0,.864l-.571,1.141a.967.967,0,0,0-.052.737l.167.5a.963.963,0,0,1-.233.988L19.143,22.5h-6.77a2.891,2.891,0,0,0-1.075.207l-1.9.543', 'M2.643,17.457l3.242-1.216a1.935,1.935,0,0,0,.967-.8l2.085-4.822a2.894,2.894,0,0,1,.86-.892l.726-.485', 'M10.946,12.205,9.4,1.373A.544.544,0,0,1,9.939.75h7.552', 'M14.162,12.75l-.846-8.409a.5.5,0,0,1,.5-.553h6.9a.5.5,0,0,1,.5.577L19.958,12.75', 'M17.088,8.621A.375.375,0,1,1,16.713,9a.375.375,0,0,1,.375-.375']],
  CashPaymentBills: ['cash-payment-bills', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.171,12.8h2.5a.483.483,0,0,1,.5.523v9.409a.483.483,0,0,1-.5.523h-2.5', 'M10.322,10.584,8.4,12.977a1.4,1.4,0,0,1-1.045.523H6.171', 'M6.171,20.534c2.144,1.625,4.1,2.716,5.363,2.716h6.273c.76,0,1.238-.054,1.568-1.045a63.517,63.517,0,0,0,1.046-7.66c0-.522-.523-1.045-1.568-1.045H12.921', 'M10.554,12.205,9.006,1.373A.546.546,0,0,1,9.546.75H17.1', 'M13.839,13.5l-.916-9.159a.5.5,0,0,1,.5-.553h6.9a.5.5,0,0,1,.5.577l-1.38,9.2', 'M16.7,8.621A.375.375,0,1,1,16.321,9a.375.375,0,0,1,.375-.375']],
  CashPaymentBill3: ['cash-payment-bill-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.875,17.25H2.625a1.5,1.5,0,0,1-1.5-1.5V7.5A1.5,1.5,0,0,1,2.625,6h18.75a1.5,1.5,0,0,1,1.5,1.5v8.75', 'M6.264 19.544L7.125 20.75 7.125 23.25', 'M7.875,4.712a1.5,1.5,0,0,0-3,0V6', 'M10.875,6V3.712a1.5,1.5,0,1,0-3,0V6', 'M13.875,6V2.25a1.5,1.5,0,0,0-3,0V6', 'M16.875,6V3.712a1.5,1.5,0,1,0-3,0V4.75', 'M16.1,23.25v-1a2.024,2.024,0,0,1,.771-1.6l2.229-1.8a2.027,2.027,0,0,0,.771-1.6V12.719a1.479,1.479,0,0,0-1.446-1.469c-1.254,0-1.5,1.415-1.511,1.465l-.285,2.067a2,2,0,0,1-.952,1.453l-1.584.939a2.015,2.015,0,0,0-.972,1.737V20.25', 'M9.579,13.844a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M11.437 14.719L11.437 15.75', 'M11.437 7.5L11.437 8.531']],
  CashPaymentBill2: ['cash-payment-bill-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 9.946L0.75 12.196', 'M.75,21a21.748,21.748,0,0,0,9.83-6.71l.234-.28c.7-.841-.3-2.032-1.383-1.532L3.685,15.13', 'M16.53,14.25l-3.3,4.091a1.029,1.029,0,0,1-1.389.209l-.12-.082a1.089,1.089,0,0,1-.413-1.234l.271-.834', 'M18.271,14.25l-.86,4.409a1.048,1.048,0,0,1-.552.735,1,1,0,0,1-.905,0l-.281-.145a1.048,1.048,0,0,1-.564-.935v-2.3', 'M18.75,3h3a1.5,1.5,0,0,1,1.5,1.5v8.25a1.5,1.5,0,0,1-1.5,1.5H13.5', 'M5.25,11.25V4.5A1.5,1.5,0,0,1,6.75,3H10.5', 'M12.579,9.344a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M14.437 10.219L14.437 11.25', 'M14.437 3L14.437 4.031']],
  CashPaymentCoinStash: ['cash-payment-coin-stash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M11.250 3.750 A6 3 0 1 0 23.250 3.750 A6 3 0 1 0 11.250 3.750 Z', 'M11.25,3.75v7.5c0,1.657,2.686,3,6,3s6-1.343,6-3V3.75', 'M23.25,7.5c0,1.657-2.686,3-6,3s-6-1.343-6-3']],
  CashPaymentCoin: ['cash-payment-coin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M18.75,3.75H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75', 'M17.25 3.75L17.25 3', 'M17.25 10.5L17.25 9.75', 'M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z']],
  CashPaymentPerson: ['cash-payment-person', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-5.403 33.597) rotate(-90)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.347 13.500 L17.847 13.500 L17.847 25.500 L10.347 25.500 Z', 'M10.877,15.75,11.544,13a1.5,1.5,0,0,1,1.811-1.106L22.1,14.006a1.5,1.5,0,0,1,1.105,1.811L22.149,20.19A1.5,1.5,0,0,1,20.1,21.216', 'M14.25,19.125a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M.75,17.25a6.755,6.755,0,0,1,8.844-6.419', 'M3.945,2.781a6.848,6.848,0,0,0,4.93,2.094,6.847,6.847,0,0,0,2.712-.558', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z']],
  CashPaymentBill: ['cash-payment-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M7.875,3a.375.375,0,1,1-.375.375A.375.375,0,0,1,7.875,3', 'M20.625,9a.375.375,0,1,1-.375.375A.375.375,0,0,1,20.625,9', 'M6.635.75h15.23A1.4,1.4,0,0,1,23.25,2.156v8.438A1.4,1.4,0,0,1,21.865,12H6.635A1.4,1.4,0,0,1,5.25,10.594V2.156A1.4,1.4,0,0,1,6.635.75Z', 'M12.000 6.000 A2.250 2.250 0 1 0 16.500 6.000 A2.250 2.250 0 1 0 12.000 6.000 Z']],
  CashPaymentWallet: ['cash-payment-wallet', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.051,9.683,4.27,7.256a1.5,1.5,0,0,1,.967-1.887L19.143.89a1.5,1.5,0,0,1,1.887.968l2.08,6.456a1.5,1.5,0,0,1-.968,1.888l-4.825,1.554', 'M17.317,18.683v2.571a1.935,1.935,0,0,1-1.941,1.929H2.758A1.935,1.935,0,0,1,.817,21.254V11.611A1.934,1.934,0,0,1,2.758,9.683H15.376a1.934,1.934,0,0,1,1.941,1.928v2.572', 'M4.567 9.698L4.567 23.183', 'M14.144,14.183a2.169,2.169,0,0,0-2.077,2.25,2.169,2.169,0,0,0,2.077,2.25h3.635a1.085,1.085,0,0,0,1.038-1.125v-2.25a1.084,1.084,0,0,0-1.038-1.125Z', 'M16.225,15.96a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M12.229,7.5a1.5,1.5,0,0,1,2.781.27']],
  CashPaymentBag1: ['cash-payment-bag-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.4,11.25c.891.648,4.1,3.875,4.1,7.684,0,3.077-3.544,4.316-6.824,4.316S6,22.011,6,18.934C6,14.973,9.5,11.6,10.32,11.1', 'M4.5,3.75H6.3c.27,0,.45.214.45.536v6.428c0,.322-.18.536-.45.536H4.5', 'M10.4,2.621,9.155,4.371a1.391,1.391,0,0,1-1.034.517H6.75', 'M6.75,9.384c2.042,1.105,3.267,1.866,4.494,1.866H15.4c1.04,0,1.231-.058,1.56-1.125C17.48,8.438,18,5.627,18,5.625c0-.562-.52-1.125-1.559-1.125l-5.027.02-1.6-2.989a.568.568,0,0,1,0-.52.46.46,0,0,1,.4-.261h5.818a.462.462,0,0,1,.405.261.566.566,0,0,1,0,.519L14.858,4.5', 'M11.079,19.094a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M12.937 19.969L12.937 21', 'M12.937 12.75L12.937 13.781']],
  CashPaymentCoin1: ['cash-payment-coin-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.457,9.228l2.872-2.713a1.957,1.957,0,0,1,1.087-.33H15.1a1.954,1.954,0,0,1,1.674.945l.35.578A1.957,1.957,0,0,1,17.2,9.6l-.317.634a1.955,1.955,0,0,1-2.133,1.043l-3.162-.632a.647.647,0,0,0-.488.1,1.937,1.937,0,0,0-.859,1.811.754.754,0,0,0,.478.629l5.349,2.057a1.956,1.956,0,0,0,1.286.041l5.709-1.783', 'M23.062,5.771,18.7,3.084A1.965,1.965,0,0,0,17.555,2.8l-7.022.413A1.957,1.957,0,0,0,9.348,3.7l-3.5,3.115a1.948,1.948,0,0,0-.556.843L4.617,9.671', 'M8.437,12.206H6.4a1.341,1.341,0,0,0-.5,2.587l2.063.826a1.342,1.342,0,0,1-.5,2.587H5.437', 'M6.937 12.206L6.937 11.456', 'M6.937 18.956L6.937 18.206', 'M8.224,9.344a5.992,5.992,0,1,0,4.588,4.636']],
  CashPaymentBill4: ['cash-payment-bill-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.125,23.25l-3-4.5V13.5c0-2-3.8-4.139-5.25-5.25', 'M15.805,14.794,12.157,11.87a1.3,1.3,0,0,0-1.843,1.843L13.848,17.7v2.5c0,1.181,1.687,3.045,1.687,3.045', 'M13.865,20.424a1.5,1.5,0,0,1-1.49,1.326h-9a1.5,1.5,0,0,1-1.5-1.5v-18a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v11', 'M7.875,14.25a3,3,0,1,1,2.24-5', 'M4.5,3a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.5,3', 'M11.25,18.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  CashPaymentBag: ['cash-payment-bag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M20.24,18.008A7.475,7.475,0,0,0,18.218,4.949l1.853-3.17a.679.679,0,0,0,0-.687A.707.707,0,0,0,19.46.75H12.04a.707.707,0,0,0-.609.342.679.679,0,0,0,0,.687l1.853,3.17A7.477,7.477,0,0,0,8.25,12', 'M13.7,13.844a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546S13.5,10.933,13.5,10.078s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M15.562 14.719L15.562 15.75', 'M15.562 7.5L15.562 8.531']]
};
exports["default"] = _default;